export enum GlobalAuditionStatus {
  AllClear = "all_clear",
  OneError = "one_error",
  MultipleErrors = "multiple_errors",
  FatalError = "fatal_error",
  Unknown = "unknown",
}
